module.exports = __webpack_public_path__ + "img/SOURCE_1.jpg";